var map = {
	"./ar/sections.json": 2238,
	"./de/sections.json": 2868,
	"./en/sections.json": 8423,
	"./es/sections.json": 6959,
	"./fr/sections.json": 7284,
	"./pt/sections.json": 1642,
	"./ru/sections.json": 1966
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9219;